import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
export function AppRouter() {
  return <BrowserRouter data-id="element-7">
      <Routes data-id="element-8">
        <Route path="/" element={<App data-id="element-10" />} data-id="element-9" />
      </Routes>
    </BrowserRouter>;
}